var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"g-recaptcha mt-5",attrs:{"id":"loginRecaptcha"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }